import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "../pages/NotFound";
import Home from "@/pages/home/page";
import Hot from "@/pages/hot/page";
import CategoryPage from "@/pages/category/page";
import ArticlePage from "@/pages/article/page";
import About from "@/pages/about/page";
import Faq from "@/pages/faq/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/hot", element: <Hot /> },
      { path: "/category/:slug", element: <CategoryPage /> },
      { path: "/article/:slug", element: <ArticlePage /> },
      { path: "/about", element: <About /> },
      { path: "/faq", element: <Faq /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;